export default __webpack_public_path__ + "static/gear-mob-54e6932bcd4f1d77b4c8f34080317a95.jpg";